import React from 'react';
// @ts-ignore
import styles from './EArchiveToolbar.module.scss';
import Tooltip from '../../../../../Components/Popup/Tooltip';
import FlyerPrintButton from '../../FlyerPrint/FlyerPrintButton/FlyerPrintButton';
import { Flyer } from '../../../Enums/Flyer.enum';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	code: string;
	workplaceId: string;
	workplaceMemberId: string;
	flyerType: Flyer;
	title: string;
	tooltipText: string;
	buttonTitle?: string;
}

const EArchiveToolbarCode: React.FC<Props> = ({
	code,
	workplaceId,
	workplaceMemberId,
	flyerType,
	title,
	tooltipText,
	buttonTitle,
}) => {
	const { t } = useTranslation();
	return (
		<div className={styles.codeWrapper}>
			<div className={styles.code}>
				{t(title)}: <span>{code}</span>
			</div>
			<Tooltip
				position='bottom center'
				trigger={
					<div>
						<img
							src='/dist/icons/v2/circle-info-solid.svg'
							alt='info'
							height='20px'
							width='20px'
						/>
					</div>
				}>
				{t(tooltipText)}
			</Tooltip>
			<FlyerPrintButton
				workplaceId={workplaceId}
				workplaceMemberId={workplaceMemberId}
				flyerType={flyerType}
				buttonTitle={buttonTitle}
			/>
		</div>
	);
};

export default EArchiveToolbarCode;
